import React from 'react'
import styles from './TileButton.module.css'

interface TileButtonProps {
    onClick: () => void
    buttonText: string
    imageSrc: string
    imageAlt: string
    dataClickLabel?: string
    selected?: boolean
}

export const TileButton = ({
    onClick,
    buttonText,
    imageSrc,
    imageAlt,
    dataClickLabel,
    selected = false
}: TileButtonProps) => {
    return (
        <button
            onClick={onClick}
            className={`${styles.button} ${selected ? styles.selected : ''}`}
            type="button"
            data-click-label={dataClickLabel}
        >
            <div className={styles.content}>
                <img src={imageSrc} alt={imageAlt} className={styles.icon} />
                <span className={styles.text}>{buttonText}</span>
            </div>
            <img src="/foodslaboEf/img/step1/rightArrow.svg" alt="矢印" className={styles.arrow} />
        </button>
    )
}
